<!-- content -->
<div class="center p-t-8 p-b-8 p-t-2-s p-b-2-s">

    <!-- tags -->
    @for (tagCategory of tagCategories; track tagCategory; let isFirst = $first) {
    <span class="inline-block bg-col-5 o1 m-t-6 p-l-1 p-r-1"
          [class.m-l-1]="!isFirst"
          [style.padding-top.px]="1"
          [style.padding-bottom.px]="1">{{tagCategory.data.name}}</span>
    }

    <!-- title -->
    @if (model?.data?.name) {
    <h1 class="m-t m-t-3-s"
        sizeClass="!S: h1, S:h2">{{model.data.name}}</h1>
    }

    <!-- author -->
    @if (typeData.author) {
    <p class="m-t-2">
        <span class="p1">{{'Words by' | translate}} </span>
        <span class="p1"
              *iCms="'author' of typeData"
              text></span>
    </p>
    }

    <!-- date & reading time -->
    <div class="p2 m-t col-11 flex flex-middle flex-justify-center">
        <p>{{typeData.date | date: 'MMMM dd, yyyy'}}</p>
        @if (typeData.date && typeData.reading_time) {
        <p>&nbsp;&#124;&nbsp;</p>
        }
        <p *iCms="'reading_time' of typeData"
           text></p>
        @if (typeData.reading_time) {
        <i class="icon-clock fs-8 m-l-1 inline-flex"></i>
        }
    </div>

    <!-- share -->
    <div class="p2 m-t-5 m-t-3-s col-11 flex flex-middle flex-justify-center pos-relative">
        <button class="flex flex-middle"
                type="button"
                (click)="toogleSocialShare()">
            <i class="icon-share inline-flex m-r-2"
               [style.font-size.rem]="1.3"
               aria-hidden="true"></i><span class="p-t-1">{{'Share' | translate }}</span>
        </button>

        @if (showSocial) {
        <div class="pos-absolute top-7 top-6-s left-0 right-0 bottom-0">
            <div class="w-4 va-m">
                <button class="cursor-pointer"
                        type="button"
                        (click)="fbShare()"
                        aria-label="Facebook">
                    <i class="icon-facebook"
                       [style.font-size.rem]="1.3"
                       aria-hidden="true"></i>
                </button>
                <button class="m-l-3 cursor-pointer"
                        type="button"
                        (click)="pinShare()"
                        aria-label="Pinterest">
                    <i class="icon-pinterest"
                       [style.font-size.rem]="1.3"
                       aria-hidden="true"></i>
                </button>
                <button class="m-l-3 cursor-pointer"
                        type="button"
                        (click)="copyUrlToClipboard()"
                        aria-label="CopyURL">
                    <i class="icon-copy"
                       [style.font-size.rem]="1.1"
                       aria-hidden="true"></i>
                </button>
            </div>
        </div>
        }
    </div>

    <!-- image -->
    <div class="m-t-8 m-t-7-s"
         [ngClass]="typeData.ratio || 'ratio-16-9'">
        @if (typeData.image) {
        <img class="rf z-1"
             [image]="typeData.image"
             [attr.alt]="model.data.name">
        }
    </div>

    <!-- component container -->
    <icms-outlet [components]="model?.data?.components"
                 [allow]="['cms-blog-component-more-stories']"></icms-outlet>

    <div class="m-t-15 m-b-8 center wrap-s">
        <p class="h2 m-b">{{'Interior Inspiration'|translate}}</p>
        <ul>
            @for (link of quickLinks; track link) {
            <li class="quick-link p1 inline-block b-radius-max p-a-2 m-r m-b-5 m-b-4-s bg-col-5 no-wrap"><a
                   [attr.href]="link.url">{{link.name}}</a></li>
            }
        </ul>
        <p class="h4 w-4-x w-4-l m-t">
            {{'Want interior tips, trends and more straight to your inbox?'|translate}}
        </p>
        <blog-newsletter-link class="block m-t-6"></blog-newsletter-link>
    </div>
</div>
